// extracted by mini-css-extract-plugin
export var button = "Carousel-module--button--f9312";
export var buttonNext = "Carousel-module--button-next--2fdb3";
export var buttonPrev = "Carousel-module--button-prev--a8b5d";
export var container = "Carousel-module--container--21f60";
export var dl = "Carousel-module--dl--b3b4d";
export var dot = "Carousel-module--dot--5e357";
export var dots = "Carousel-module--dots--ba903";
export var gap = "Carousel-module--gap--b2faf";
export var isDraggable = "Carousel-module--is-draggable--ae38f";
export var isDragging = "Carousel-module--is-dragging--1c4ca";
export var isSelected = "Carousel-module--is-selected--bf5af";
export var modalRoot = "Carousel-module--modal-root--f4482";
export var slide = "Carousel-module--slide--b0607";
export var thumb = "Carousel-module--thumb--abb50";
export var thumbnails = "Carousel-module--thumbnails--fec81";
export var viewport = "Carousel-module--viewport--96c08";
export var wrapper = "Carousel-module--wrapper--a3e73";